import React, { useRef, useState } from "react";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import {ErrorMessage, useForm} from "react-hook-form";
import { connect } from "react-redux";
import * as Yup from "yup";



// components
import { ButtonCancel, ButtonSubmit, GenericTableButton } from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {
    FORM,
    MAX_NAME,
    REQUIRED
} from "../../../components/i18n/i18n";
import { MAX_NAME_SIZE } from "../../../components/menu-flower/constants";
import { TT_HISTORY } from "../../../components/i18n/toolTips";
import { FL_CODE, FL_PROJECT } from "../../../components/i18n/formLabels";
import { PH_CODE} from "../../../components/i18n/placeHolders";

// actions
import { setLoading, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { resetCombos, setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { genericActions } from "../../../redux/actions/generics/GenericActions";

// services

// providers
import Switch from "react-bootstrap-switch";
import {fbProjectProvider} from "../../../providers/fbProjectProvider";
import {fbDatabaseService} from "../../../jwt/_services/firebase/fbDatabaseService";


const FbDataBaseForm = props => {
    const { editMode, disableInputs, domainObject } = props.formProps;

    const [showModal, setShowModal] = useState(true)
    const [fbProjectId, setFbProjectId] = useState(domainObject?.project?.id || null);
    const [principal, setPrincipal] = useState(domainObject?.principal || true );

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            code: domainObject?.code,
            url: domainObject?.url,
            defaultDatabaseName: domainObject?.defaultDatabaseName,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            ...data,
            principal : principal
        };

        if (fbProjectId !== null)
            dataRequest.project = { id : fbProjectId }

        if (editMode) {
            let id = domainObject.id;
            dataRequest.id = id

            genericActions.update(fbDatabaseService, id, dataRequest)
        } else {
            genericActions.save(fbDatabaseService, dataRequest)
        }


        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose();
    }

    return (<>
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_CODE}</Label>
                                <Input type="text" name="code"
                                       placeholder={PH_CODE}
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label>{ FL_PROJECT }</Label>
                                <SelectGeneric
                                    title={ FL_PROJECT }
                                    initialValue={ fbProjectId }
                                    setExternalValue={ setFbProjectId }
                                    provider={ fbProjectProvider }
                                />
                            </FormGroup>
                        </Col>
                        <Col  md="3">
                            <FormGroup>
                                <Label>{ 'Base principal' }</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={principal}
                                    onChange={() => setPrincipal(!principal)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <Label>{ 'Nombre de la base de datos default' }</Label>
                                <Input type="text"
                                       name="defaultDatabaseName"
                                       placeholder={ 'Nombre de la base de datos' }
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <Label>{ 'URL' }</Label>
                                <Input type="text"
                                       name="url"
                                       placeholder={ 'URL' }
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}


const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(FbDataBaseForm)